import r from "../../shared-lib/braze-shared-lib.js";
import { getErrorMessage as ei } from "./error-utils.js";
import { decodeBrazeActions as to } from "./string-utils.js";
import {
  BRAZE_ACTION_URI_REGEX as X,
  isValidBrazeActionType as ro,
  isValidBrazeActionJson as Y,
} from "./validation-utils.js";
export const BRAZE_ACTIONS = {
  types: {
    ue: "container",
    logCustomEvent: "logCustomEvent",
    setEmailNotificationSubscriptionType:
      "setEmailNotificationSubscriptionType",
    setPushNotificationSubscriptionType: "setPushNotificationSubscriptionType",
    setCustomUserAttribute: "setCustomUserAttribute",
    requestPushPermission: "requestPushPermission",
    addToSubscriptionGroup: "addToSubscriptionGroup",
    removeFromSubscriptionGroup: "removeFromSubscriptionGroup",
    addToCustomAttributeArray: "addToCustomAttributeArray",
    removeFromCustomAttributeArray: "removeFromCustomAttributeArray",
    pe: "openLink",
    je: "openLinkInWebView",
  },
  properties: { type: "type", me: "steps", le: "args" },
};
export const INELIGIBLE_BRAZE_ACTION_URL_ERROR_TYPES = {
  _r: "unknownBrazeAction",
  Or: "noPushPrompt",
};
export const ineligibleBrazeActionURLErrorMessage = (t, o) => {
  switch (t) {
    case INELIGIBLE_BRAZE_ACTION_URL_ERROR_TYPES._r:
      return `${o} contains an unknown braze action type and will not be displayed.`;
    case INELIGIBLE_BRAZE_ACTION_URL_ERROR_TYPES.Or:
      return `${o} contains a push prompt braze action, but is not eligible for a push prompt. Ignoring.`;
    default:
      return "";
  }
};
export function getDecodedBrazeAction(t) {
  try {
    const o = t.match(X),
      e = o ? o[0].length : null,
      n = e ? t.substring(e) : null;
    if (null == e || e > t.length - 1 || !n)
      return void r.j.error(
        `Did not find base64 encoded brazeAction in url to process : ${t}`,
      );
    const i = to(n);
    return i
      ? JSON.parse(i)
      : void r.j.error(`Failed to decode base64 encoded brazeAction: ${n}`);
  } catch (o) {
    return void r.j.error(`Failed to process brazeAction URL ${t} : ${ei(o)}`);
  }
}
function eo(t, o) {
  let r = !1;
  if (o) for (const e of o) if (((r = r || t(e)), r)) return !0;
  return !1;
}
export function containsUnknownBrazeAction(t) {
  const o = BRAZE_ACTIONS.properties.type,
    r = BRAZE_ACTIONS.properties.me;
  try {
    if (null == t) return !0;
    const e = t[o];
    return e === BRAZE_ACTIONS.types.ue
      ? eo(containsUnknownBrazeAction, t[r])
      : !ro(e);
  } catch (t) {
    return !0;
  }
}
export function containsPushPrimerBrazeAction(t) {
  if (!t || !Y(t)) return !1;
  const o = BRAZE_ACTIONS.properties.type,
    r = BRAZE_ACTIONS.properties.me,
    e = t[o];
  return e === BRAZE_ACTIONS.types.ue
    ? eo(containsPushPrimerBrazeAction, t[r])
    : e === BRAZE_ACTIONS.types.requestPushPermission;
}
